export default __webpack_public_path__ + "7bf96ad7032433459122820f4d30f7ff.png";